$(document).on('click', '#btn-cancel-reply', function(e) {
  $('.reply-box').html('');
  $('#btn-reply').show();
  return false;
});
